import { lighten } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  statement: {
    margin: theme.spacing(4, 0),
    color: lighten(theme.palette.text.dark, 0.25),
    lineHeight: '1.5em',
  },
  title: {
    display: 'flex',
    flexGrow: 1,
    paddingLeft: theme.spacing(3),
    textAlign: 'center',
    marginTop: theme.spacing(3),
    color: theme.palette.text.dark,
  },
  fields: {
    padding: theme.spacing(0, 3),
    '&:last-child': {
      padding: theme.spacing(0, 3, 0, 0),
    },
  },
}))
